export function buildTabloidHTML(pages) {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8" />
  <style>
    /* Reset básico para evitar margens indesejadas no PDF */
    * { box-sizing: border-box; }
    body { margin:0; padding:0; -webkit-print-color-adjust: exact; }
    
    /* Nota: Para as fontes funcionarem, o ideal é que o back-end 
       também as injete via Base64, ou que estejam em um CDN (HTTPS) */
    
    @font-face {
        font-family: 'fontName';
        /* O Node vai substituir isso pelo Base64 real */
        src: url('{{FONT_NAME_SRC}}') format('opentype');
        font-weight: 400;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'fontPrice';
        /* O Node vai substituir isso pelo Base64 real */
        src: url('{{FONT_PRICE_SRC}}') format('opentype');
        font-weight: 400;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'FontCarac';
        src: url('{{FONT_CARAC_SRC}}') format('opentype');
    }

    .page {
      width: 1080px;
      height: 1920px;
      position: relative;
      overflow: hidden;
      background: #fff;
      page-break-after: always;
      display:block
    }
    
    .page:last-child { page-break-after: auto; }
  </style>
</head>
<body>
  ${pages.map(renderPage).join('')}
</body>
</html>
`;
}

function renderPage(page, index) {
  if (index === 0 && page.isCover) {
    return renderCover(page);
  }
  return `
<div class="page">
  ${page.background ? renderBackground("{{BACKGROUND_SRC}}") : ""}
  
  ${page.placed.map(p => `
    ${renderProductName(p)}
    ${renderProductCarac(p)}
    ${renderProductPrice(p)}
    ${renderProduct(p)}
    ${renderProductInstallments(p)}
    ${renderProductTotalTerm(p)}
    ${renderProductParcela(p)}
  `).join("")}
  ${renderValidity(page.validate)}
</div>
`;
}

// Nova função apenas para a Capa
// function renderCover(page) {
//   // Removi o display:flex para o texto poder obedecer ao X e Y absoluto
//   return `<div class="page" style="position: relative;">
//     ${page.background ? renderBackground("{{COVER_SRC}}") : ""}
//     ${page.coverText ? `
//        <div style="
//             position: absolute; 
//             z-index: 10; 
//             top: ${page.coverTextPosition.y}px;
//             left: ${page.coverTextPosition.x}px;
//             color: ${page.coverFontColor}; 
//             font-family: 'fontName';
//             white-space: nowrap; /* Evita quebra de linha indesejada */
//        ">
//           <div style="
//             font-size: ${page.coverFontSize}px;
//             margin: 0; 
//             line-height: 1.1;
//             text-shadow: 2px 2px 4px rgba(0,0,0,0.5); /* Sombra para leitura */
//           ">
//             ${page.coverText}
//           </div>
//        </div>
//        ` : ''}
//        ${page.placed && page.placed.length > 0 ? page.placed.map(p => `
//         ${renderProductName(p)}
//         ${renderProductCarac(p)}
//         ${renderProductPrice(p)}
//         ${renderProduct(p)}
//         ${renderProductInstallments(p)}
//         ${renderProductTotalTerm(p)}
//         ${renderProductParcela(p)}
//     `).join("") : ""}

//     ${renderValidity(page.validate)}
//   </div>`;
// }

function renderCover(page) {
  // O segredo é garantir que não existam espaços entre as tags (usando .trim() e join(''))
  const productsHTML = page.placed && page.placed.length > 0 
    ? page.placed.map(p => `
        ${renderProduct(p)}
        ${renderProductName(p)}
        ${renderProductCarac(p)}
        ${renderProductPrice(p)}
        ${renderProductInstallments(p)}
        ${renderProductTotalTerm(p)}
        ${renderProductParcela(p)}
      `).join("").trim() 
    : "";

  return `
<div class="page" style="background: #000; position: relative; width: 1080px; height: 1920px; overflow: hidden; display: block;">
    ${page.background ? renderBackground("{{COVER_SRC}}") : ""}
    
    ${page.coverText ? `
       <div style="position: absolute; z-index: 20; top: ${page.coverTextPosition?.y || 0}px; left: ${page.coverTextPosition?.x || 0}px; color: ${page.coverFontColor || 'white'}; font-family: 'fontName'; white-space: nowrap;">
          <div style="font-size: ${page.coverFontSize}px; text-transform: uppercase; margin: 0; line-height: 1.1; text-shadow: 2px 2px 4px rgba(0,0,0,0.5);">
            ${page.coverText}
          </div>
       </div>` : ''}

    <div style="position: absolute; top: 0; left: 0; width: 1080px; height: 1920px; z-index: 10; pointer-events: none;">
        ${productsHTML}
    </div>

    ${renderValidity(page.validate)}
</div>`.trim();
}

function renderBackground(src) {
  return `
<img src="${src}"
     style="position:absolute; inset:0; width:100%; height:100%; object-fit:cover; z-index:0;" />
`;
}

function renderProductName(p) {
  return `
<div style="
    position:absolute;
    left:${p.nameX}px;
    top:${p.nameY}px;
    width:${p.nameW ?? 300}px;
    font-size:${p.fontProductName};
    font-family:'fontName';
    line-height:1.1;
    color:#fff;
    white-space: nowrap;;
    word-break:break-word;
    z-index:10;
">
  ${p.name || ''} </div>
`;
}

function renderProductCarac(p) {
  // Gera o HTML das características primeiro
  const caracsHTML = `
    ${p.carac_1 ? `${p.carac_1}<br>` : ''}
    ${p.carac_2 ? `${p.carac_2}<br>` : ''}
    ${p.carac_3 ? `${p.carac_3}<br>` : ''}
    ${p.carac_4 ? `${p.carac_4}<br>` : ''}
  `;

  // Gera o HTML do vídeo apenas se existir o link
  const videoIconHTML = p.videoLink ? `
    <div style="margin-top: 10px;">
        <a href="${p.videoLink}" target="_blank" rel="noopener noreferrer" style="display:inline-block;">
            <img src="https://raiox-produtos.s3-sa-east-1.amazonaws.com/click_video.png" 
                style="width: ${p.clickVideo || '80px'}; height: auto; display: block; cursor: pointer;" 
                alt="Ícone Vídeo" 
            />
        </a>
    </div>
  ` : '';

  return `
    <div style="
        position:absolute;
        left:${p.caracX}px;
        top:${p.caracY}px;
        font-size:${p.fontProductCarac};
        font-family: 'FontCarac';
        line-height:1.1;
        color:#fff;
        white-space: nowrap;
        z-index:10;
    ">
        ${caracsHTML}
        ${videoIconHTML}
    </div>
  `;
}

function renderProduct(p) {
  return `
<div style="
    position:absolute;
    left:${p.imageX}px;
    top:${p.imageY}px;
    width:${p.imageW}px;
    height:${p.imageH}px;
    z-index:5;
">
    <img src="https://raiox-produtos.s3-sa-east-1.amazonaws.com/${p.code}_face.png" 
         style="width:100%; height:100%; object-fit:contain; pointerEvents: none" />
</div>
`;
}

function renderProductPrice(p) {
  return `
<div style="
    position: absolute;
    left: ${p.priceX ?? 0}px;
    top: ${p.priceY ?? 0}px;
    width: 200px;
    z-index: 15;
">
    <strong style="
        font-size: ${p.fontProductPrice};
        color: #d7ec13;
        font-family: 'fontPrice';
        line-height: 1;
    ">
        ${p.price || ''}
    </strong>
</div>
`;
}

function renderProductInstallments(p) {
  return `
<div style="
    position: absolute;
    left: ${p.installmentsX ?? 0}px;
    top: ${p.installmentsY ?? 0}px;
    width: 100%;
    z-index: 15;
">
    <strong style="
        font-size: ${p.fontProductInstallmentsText};
        color: #fff;
        font-family: 'fontName';
        line-height: 1;
    ">
        ${p.installments || ''}
    </strong>
</div>
`;
}

function renderProductTotalTerm(p) {
  return `
<div style="
    position: absolute;
    left: ${p.totalTermX ?? 0}px;
    top: ${p.totalTermY ?? 0}px;
    width: 100%;
    z-index: 15;
">
    <strong style="
        font-size: ${p.fontProductTotalTerm};
        color: #fff;
        font-family: 'fontName';
        line-height: 1;
    ">
        Total à Prazo: ${p.totalAPrazo || ''}
    </strong>
</div>
`;
}

function renderProductParcela(p) {
  const tags = [
    p.noInterest ? "Sem Juros" : "",
    p.noDownPayment ? "Sem Entrada" : "",
    p.onCard ? "No Cartão" : "",
    p.onTicket ? "No Carnê" : ""
  ].filter(text => text !== "");

  const tagsHTML = tags.map(tag => `
    <p style="
        font-size: ${p.fontPaymentTags}; 
        color: #fff; 
        font-weight: bolder; 
        margin: 0; 
        padding: 0;
        font-family: 'fontName';
        line-height: 1.0;
    ">
        ${tag}
    </p>
  `).join("");

  return `
<div style="
    position: absolute;
    left: ${p.parcelasX ?? 0}px;
    top: ${p.parcelasY ?? 0}px;
    width: 200px;
    z-index: 15;
    line-height: 0; /* 🔥 Mata espaços fantasmas entre elementos de bloco */
">
    <strong style="
        font-size: ${p.fontProductInstallments};
        color: #fff;
        font-family: 'fontName';
        display: block;
        line-height: 0.8; /* 🔥 Reduz a 'caixa' do número para o texto das tags subir */
        margin-bottom: 2px; /* 💡 Controle o espaço real aqui */
    ">
        ${p.parcelas || ''}x
    </strong>
    
    <div style="line-height: 1.0;">
        ${tagsHTML}
    </div>
</div>
`;
}

function renderValidity(validate) {
  if (!validate) return "";
  const formattedDate = new Date(validate).toLocaleDateString("pt-BR");
  return `
<div style="
    position: absolute;
    bottom: 5px; /* Subindo um pouco da borda inferior */
    left: 0;
    width: 100%;
    text-align: center;
    z-index: 100;
    pointer-events: none;
">
    <p style="
        color: #fff;
        font-size: 15px;
        margin: 0;
        font-weight: bold;
        font-family: 'fontName';
        text-shadow: 1px 1px 2px rgba(0,0,0,0.8);
    ">
        Ofertas Válidas Até: ${formattedDate}
    </p>
</div>
`;
}